import { styled } from 'styled-components';

import TermsLayout from './TermsLayout';

const Container = styled.div`
  position: absolute;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  flex: 1;
  align-self: center;

  margin: 10pt;
  margin-top: 5rem;
  margin-bottom: 10pt;
  padding: 10pt;

  max-width: 30rem;
  min-height: 0;

  border: 2pt solid gray;

  font-size: 32pt;

  color: #0000ff;

  z-index: 2;

  background-color: #c0c0c0;

  // drop shadow
  box-shadow: 0pt 4pt 4pt 0 rgba(0, 0, 0, 0.5);

  a {
    padding: 4pt;
    font-size: 3rem;
    cursor: pointer;

    border: 2pt solid gray;

    &:hover {
      color: #ff0000;
    }
  }
`;

type Props = {
  onPressBack: () => void;
};

export default function CreateGamePanel(props: Props) {
  return (
    <Container>
      <a onClick={props.onPressBack}>{'X'}</a>
      <TermsLayout />
    </Container>
  );
}
